import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLogin } from "../../../../context/LoginContext";
import { queryKey } from "../../../../enumerations/queryKey";
import { useFacebookPixel } from "../../../../hooks/fbPixel/fbPixel.hooks";
import { useGtm } from "../../../../hooks/gtm/gtm.hooks";
import { useOkSpinPixel } from "../../../../hooks/okSpinPixel/okSpinPixel.hooks";
import { useTikTokPixel } from "../../../../hooks/tiktokPixel/tiktokPixel.hooks";
import { useGetDepositCount, usePutDepositRead } from "./hooks/index.hook";

const DepositMessage = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { isLogin } = useLogin();
  const { isHavePixelIntegration, pixelCreateTracker, pixelCreateCustomTracker } =
    useFacebookPixel();
  const { isHaveGCode, pushEvent: pushGCodeEvent } = useGtm();
  const { isHaveTikTokPixel, identify, trackEvent } = useTikTokPixel();
  const { isHaveOkSpinPixel, pushEvent } = useOkSpinPixel();

  const { data } = useGetDepositCount({ options: { enabled: !!isLogin } });
  const { mutate: putDepositRead } = usePutDepositRead();

  useEffect(() => {
    if (data && data.length > 0) {
      console.debug("data", data);
      data.forEach((item) => {
        const properties = {
          content_id: item.trans_id,
          content_type: "product",
          content_name: t(`transaction.status.${item.trans_type}`),
          value: item.trade_amount,
        };
        if (item.deposit_count === 1) {
          console.debug("You have deposit once:", item.deposit_count);
          if (isHavePixelIntegration) {
            pixelCreateCustomTracker({
              eventId: "FirstDeposit",
              props: properties,
            });
          }
          if (isHaveGCode) {
            pushGCodeEvent({
              eventName: "first_deposit",
              properties,
            });
          }
          if (isHaveTikTokPixel) {
            identify({
              external_id: item.trans_id,
            });
            trackEvent({
              eventName: "FirstDeposit",
              properties,
            });
          }
          if (isHaveOkSpinPixel) {
            pushEvent({
              eventName: "EVENT_FIRST_DEPOSIT",
              properties,
            });
          }
        } else {
          console.debug("You have deposit more than once:", item.deposit_count);
          if (isHavePixelIntegration) {
            pixelCreateTracker({
              eventId: "Purchase",
              props: properties,
            });
          }
          if (isHaveGCode) {
            pushGCodeEvent({
              eventName: "purchase",
              properties,
            });
          }
          if (isHaveTikTokPixel) {
            identify({
              external_id: item.trans_id,
            });
            trackEvent({
              eventName: "Purchase",
              properties,
            });
          }
          if (isHaveOkSpinPixel) {
            pushEvent({
              eventName: "EVENT_PURCHASE",
              properties,
            });
          }
        }
      });

      const trans_ids = data.map((item) => item.trans_id);
      putDepositRead(
        { trans_ids },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [queryKey.DEPOSIT_COUNT] });
          },
        },
      );
    }
  }, [data, isHaveGCode, isHaveTikTokPixel, isHaveOkSpinPixel]);

  return null;
};

export default DepositMessage;
